import { render, staticRenderFns } from "./CashTransfer.vue?vue&type=template&id=28cbc298"
import script from "./CashTransfer.vue?vue&type=script&lang=js"
export * from "./CashTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports